import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { spacing } from 'ui/theme';

const WarningBannerWrapper = styled.div`
  margin-bottom: ${spacing.plusHalf};
`;

export const HeatmapErrorBanner = () => {
  return (
    <WarningBannerWrapper data-test="heatmap-error-banner">
      <WarningBanner>
        Unable to track every link in this campaign. Links need to have opening and closing a tags
        in the template or snippet, properly formed handlebars and be valid html to be trackable.
      </WarningBanner>
    </WarningBannerWrapper>
  );
};
